import { lazyWithRetry } from 'utils/lazyWithRetry';

export const AsyncAdminRedirect = lazyWithRetry(() => import('./AdminRedirect'));
export const AsyncCreateAccount = lazyWithRetry(() => import('./CreateAccount'));
export const AsyncDashboard = lazyWithRetry(() => import('./Dashboard'));
export const AsyncHome = lazyWithRetry(() => import('./Home'));
export const AsyncHomeAuthenticated = lazyWithRetry(() => import('./HomeAuthenticated'));
export const AsyncLogin = lazyWithRetry(() => import('./Login'));
export const AsyncLogout = lazyWithRetry(() => import('./Logout'));
export const AsyncNotFound = lazyWithRetry(() => import('./NotFound'));
export const AsyncPasswordReset = lazyWithRetry(() => import('./PasswordReset'));
export const AsyncSetPassword = lazyWithRetry(() => import('./SetPassword'));
export const AsyncUser = lazyWithRetry(() => import('./Settings'));

export const AsyncBookingList = lazyWithRetry(() => import('../containers/BookingList'));
export const AsyncOffersList = lazyWithRetry(() => import('../containers/OffersList'));
